import React from 'react';
import { ContactInfoCard } from './contact/ContactInfoCard';
import { ContactForm } from './contact/ContactForm';

export const ContactSection = () => (
  <section id="contact" className="section section-alt" data-testid="contact-section">
    <div className="container">
      <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
        <h2 className="heading-1" data-testid="contact-heading">
          Talk to a Hooghly-based wealth advisor
        </h2>
        <p className="body-large" style={{ maxWidth: '780px', margin: '0 auto', color: 'var(--text-secondary)' }}>
          Send us a brief — we'll reply within 2–4 working hours. Or chat instantly on WhatsApp.
        </p>
      </div>

      <div
        className="contact-layout"
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(280px, 1fr) minmax(320px, 1.2fr)',
          gap: '2.5rem',
          alignItems: 'stretch'
        }}
      >
        <ContactInfoCard />
        <ContactForm />
      </div>
    </div>
  </section>
);
